import React from 'react';
import { MessageSquareIcon, FolderIcon, FileTextIcon, WorkflowIcon, BarChartIcon, BookOpenIcon } from 'lucide-react';
export function FeaturesSection() {
  const features = [{
    icon: MessageSquareIcon,
    title: 'Fallannahme & Mandantenkommunikation',
    description: 'Automatische Informationsabfrage, strukturierte Dialogführung, Dokumenten-Upload und qualifizierte Vorprüfung.'
  }, {
    icon: FolderIcon,
    title: 'Aktenanlage & Datenübertragung',
    description: 'Ein Klick – und alle Daten werden in Ihrer Kanzleisoftware angelegt.'
  }, {
    icon: FileTextIcon,
    title: 'Intelligente Dokumentengenerierung',
    description: 'Vom Erstschreiben bis zum Schriftsatz – präzise Vorlagen, automatisch vorausgefüllt und juristisch korrekt strukturiert.'
  }, {
    icon: WorkflowIcon,
    title: 'Prozess-Workflows für Verkehrsrecht',
    description: 'Unfallregulierung, Bußgeld, Schadenshöhe, Haftungsquote, Versicherer – alles wird systematisch abgebildet.'
  }, {
    icon: BarChartIcon,
    title: 'Dashboard & Controlling',
    description: 'Transparente Übersicht aller offenen Vorgänge, Fristen, Dokumente und Fortschritte.'
  }, {
    icon: BookOpenIcon,
    title: 'Vollständige Automatisierungsbibliothek',
    description: 'Bestehend aus vorkonfigurierten Modulen speziell für das Verkehrsrecht, basierend auf tausenden realen Fällen.'
  }];
  return <section className="py-20 bg-gray-50" data-id="element-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-33">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-34">
          <h2 id="features" className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6" data-id="element-35">
            Die wichtigsten Funktionen im Überblick
          </h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-36">
          {features.map((feature, index) => <div key={index} className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow" data-id="element-37">
              <feature.icon className="w-10 h-10 text-blue-600 mb-4" data-id="element-38" />
              <h3 className="text-lg font-bold text-gray-900 mb-3" data-id="element-39">
                {index + 1}. {feature.title}
              </h3>
              <p className="text-gray-700" data-id="element-40">{feature.description}</p>
            </div>)}
        </div>
      </div>
    </section>;
}